import React from 'react';
import Modal from '../Modal';
import Button from '../Button';
import { MESSAGES } from 'constants/messages';

/**
 * Confirmation dialog built on top of Modal. Used for destructive actions.
 * Controlled via `isOpen`; resolves through onConfirm/onCancel callbacks.
 */
const ConfirmDialog = ({
  isOpen,
  onConfirm,
  onCancel,
  title = MESSAGES.CONFIRM.DELETE_TITLE,
  message = MESSAGES.CONFIRM.DELETE_BODY,
  confirmLabel = 'Delete',
  cancelLabel = 'Cancel',
  confirmVariant = 'danger',
  loading = false,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={onCancel}
    title={title}
    size="sm"
    closeOnBackdrop={!loading}
    footer={
      <>
        <Button variant="secondary" onClick={onCancel} disabled={loading}>
          {cancelLabel}
        </Button>
        <Button variant={confirmVariant} onClick={onConfirm} loading={loading}>
          {confirmLabel}
        </Button>
      </>
    }
  >
    <p className="u-text-muted">{message}</p>
  </Modal>
);

export default ConfirmDialog;
